<template>
    <div class="d-flex align-items-start">
        <!-- Links: Person Icon und Nummer -->
        <div class="d-flex flex-column align-items-center me-3">
            <einzelperson_icon />
            <span class="mt-1"><strong>{{ index + 1 }}.</strong> Person</span>
        </div>            
    </div>
</template>

<script setup>

import einzelperson_icon from "@/components/icons/einzelperson_icon.vue";


const props = defineProps({    
    index: {
        type: Number,
        default: 0
    }
})

</script>
